import { jwtDecode, InvalidTokenError } from "jwt-decode";

import { LocalStorageItem } from "../utils/localStorage";

const ACCESS_TOKEN_KEY = "tz_accessToken";
const REFRESH_TOKEN_KEY = "tz_refreshToken";

export const accessTokenStorage = new LocalStorageItem(ACCESS_TOKEN_KEY);
export const refreshTokenStorage = new LocalStorageItem(REFRESH_TOKEN_KEY);

type DecodedToken = {
  userId: string;
  exp?: number;
};

export function decode(token: string) {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    if (error instanceof InvalidTokenError) {
      accessTokenStorage.remove();
      refreshTokenStorage.remove();
    }

    throw error;
  }
}
